// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"39c3718b","239":"2d37b715","455":"429ad6c0"}[chunkId] + ".chunk.js";
};